import { isValidCardNumber } from '@chikara/utils';
import { CARD_NUMBER_LENGTH } from './activateCard.constants';
import { formatCurrency } from '@chikara/utils';
import { t } from '@/i18n';

// VALIDATORS
export const validateFullName = (value: string): string | undefined => {
    if (!value.trim()) {
        return t('dashboard.card.activateModal.errors.fullNameRequired');
    }
    return undefined;
};

export const validateCardNumber = (value: string): string | undefined => {
    const cleaned = value.replace(/[\s\-]/g, '');
    if (!cleaned) {
        return t('dashboard.card.activateModal.errors.cardNumberRequired');
    }
    if (!isValidCardNumber(cleaned)) {
        return t('dashboard.card.activateModal.errors.cardNumberInvalid');
    }
    return undefined;
};

export const validateConfirmCardNumber = (value: string, original: string): string | undefined => {
    const cleaned = value.replace(/[\s\-]/g, '');
    if (!cleaned) {
        return t('dashboard.card.activateModal.errors.confirmCardNumberRequired');
    }
    const cardCleaned = original.replace(/[\s\-]/g, '');
    if (cleaned !== cardCleaned) {
        return t('dashboard.card.activateModal.errors.confirmCardNumberMismatch');
    }
    return undefined;
};

export const validateSpendingLimit = (value: string): string | undefined => {
    const numeric = value.replace(/\D/g, '');
    const numValue = Number(numeric) / 100;

    if (!value || isNaN(numValue) || numValue <= 0) {
        return t('dashboard.card.activateModal.errors.spendingLimitInvalid');
    }
    return undefined;
};

export const validateOnlyNumbers = (value: string): string => {
    return value.replace(/\D/g, '').slice(0, CARD_NUMBER_LENGTH);
};

// FORMATTERS
export const formatCardNumber = (value: string): string => {
    return value.replace(/(.{4})/g, '$1 ').trim();
};

export const formatCurrencyInput = (value: string): string => {
    const numeric = value.replace(/[^\d]/g, '');
    if (!numeric) return '';

    const number = Number(numeric) / 100;

    return formatCurrency(number);
};

export const lastFourDigits = (cardNumber: string): string => cardNumber.slice(-4);
